import remodal from "remodal"
window.collect = require('collect.js')
window.get = require('lodash/get')
window.kebabCase = require('lodash/kebabCase')
window.Cookies = require('js-cookie');
window.moment = require('moment')
import auth from "./api/auth"

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.interceptors.response.use(
    response => response,
    async error => {
        const { status, config } = error.response

        // Handle Session Timeouts
        if (status === 401) {
            window.location.href = '/login'
        }

        // Handle CSRF TOKEN
        if (status === 419 && ! config._retry) {
            config._retry = true

            try {
                let response = await auth.refreshToken()
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data
                config.headers['X-CSRF-TOKEN'] = response.data;
            } catch (e) {
                return Promise.reject(error)
            }

            return window.axios.request(config)
        }

        return Promise.reject(error)
    }
)

window.app_url = process.env.MIX_APP_URL;

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: 'eu',
    forceTLS: true
});
